// XO Latest Insights carousel
// - No manual scroll / drag
// - Slides move only when a dot is clicked
// - Dots only appear when content overflows viewport
(function () {
  function init(root) {
    if (!root || root.dataset.xoInit === '1') return;
    root.dataset.xoInit = '1';

    const viewport = root.querySelector('[data-xo-insights-viewport]');
    const track = root.querySelector('[data-xo-insights-track]');
    const pager = root.querySelector('[data-xo-insights-pager]');
    if (!viewport || !track || !pager) return;

    const slides = Array.from(track.children);
    if (!slides.length) return;

    let step = 0;
    let currentIndex = 0;
    let dots = [];

    // Distance between first two slides (includes gap)
    function computeStep() {
      if (slides.length < 2) return 0;
      return slides[1].offsetLeft - slides[0].offsetLeft;
    }

    function setActive(index) {
      dots.forEach((btn, i) => {
        const active = i === index;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function goTo(index) {
      if (!step) step = computeStep();
      if (!step) return;

      const maxIndex = slides.length - 1;
      const clamped = Math.max(0, Math.min(maxIndex, index));
      const x = step * clamped;

      track.style.transform = `translateX(-${x}px)`;
      currentIndex = clamped;
      setActive(clamped);
    }

    function buildDots() {
      pager.innerHTML = '';
      dots = [];

      slides.forEach((_, i) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'xo-insights__dot' + (i === currentIndex ? ' is-active' : '');
        btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        btn.setAttribute('aria-current', i === currentIndex ? 'true' : 'false');

        btn.addEventListener('click', function () {
          goTo(i);
        });

        pager.appendChild(btn);
        dots.push(btn);
      });
    }

    function refresh() {
      step = computeStep();

      const overflow = track.scrollWidth - viewport.clientWidth;
      const canSlide = slides.length > 1 && overflow > 2 && step > 0;

      if (!canSlide) {
        // No clipping: reset transform and hide pager
        track.style.transform = 'translateX(0)';
        pager.innerHTML = '';
        currentIndex = 0;
        return;
      }

      // Clipping exists: show dots and align to current slide
      buildDots();
      goTo(currentIndex);
    }

    // Initial
    refresh();

        // --- Swipe support (mobile) ---
    let startX = null;
    let startY = null;
    let swiping = false;

    viewport.addEventListener('touchstart', function (e) {
      if (!e.touches || e.touches.length !== 1) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      swiping = false;
    }, { passive: true });

    viewport.addEventListener('touchmove', function (e) {
      if (startX === null || !e.touches || e.touches.length !== 1) return;

      const dx = e.touches[0].clientX - startX;
      const dy = e.touches[0].clientY - startY;

      // Only treat as swipe if mostly horizontal
      if (!swiping && Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) {
        swiping = true;
      }

      // If swiping horizontally, stop the page from scrolling horizontally/triggering weird gestures
      if (swiping) e.preventDefault();
    }, { passive: false });

    viewport.addEventListener('touchend', function (e) {
      if (startX === null) return;

      const endX = (e.changedTouches && e.changedTouches[0].clientX) || startX;
      const dx = endX - startX;
      const threshold = 40;

      // Only move if carousel can slide (same logic as refresh uses)
      const overflow = track.scrollWidth - viewport.clientWidth;
      const canSlide = slides.length > 1 && overflow > 2 && computeStep() > 0;

      if (canSlide && swiping && Math.abs(dx) > threshold) {
        if (dx < 0) goTo(currentIndex + 1); // swipe left => next
        else goTo(currentIndex - 1);        // swipe right => prev
      }

      startX = null;
      startY = null;
      swiping = false;
    }, { passive: true });
    // Recalculate on resize
    window.addEventListener('resize', refresh);
  }

  function initAll() {
    document.querySelectorAll('[data-xo-insights]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();